import React from "react";
import { Box, Text, Wrap } from "@chakra-ui/react";
import { SortableContext } from "@dnd-kit/sortable";
import { Word } from "./Word";
import { useDroppable } from "@dnd-kit/core";

export const WORD_BANK_ID = "words";

type WordBankProps = {
  words: string[];
};

export function WordBank({ words }: WordBankProps) {
  const { setNodeRef, isOver, over } = useDroppable({ id: WORD_BANK_ID });
  const isDraggingOver =
    isOver || (over ? words.includes(over.id.toString()) : false);
  return (
    <SortableContext items={words}>
      <Box
        rounded="md"
        mt="4"
        p="2"
        borderWidth={1}
        borderColor={isDraggingOver ? "primary" : undefined}
        maxW="300px"
        ref={setNodeRef}
      >
        <Text mb="2" fontSize="sm">
          Drag items from this box to the blanks above
        </Text>
        <Wrap>
          {words.map((word, index) => (
            <Word key={index} id={word}>
              {word}
            </Word>
          ))}
        </Wrap>
      </Box>
    </SortableContext>
  );
}
